import {
    Component,
    OnInit,
    ViewChild,
    Injector,
    ElementRef
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/AppConsts';
import {
    ProfileServiceProxy,
    ChangePasswordInput,
    PasswordComplexitySetting
} from '@shared/service-proxies/service-proxies';

@Component({
    selector: 'changePasswordModal',
    templateUrl: './change-password-modal.component.html'
})
export class ChangePasswordModalComponent extends AppComponentBase {
    @ViewChild('currentPasswordInput') currentPasswordInput: ElementRef;
    @ViewChild('changePasswordModal') modal: ModalDirective;

    passwordComplexitySetting: PasswordComplexitySetting = new PasswordComplexitySetting();
    currentPassword: string;
    password: string;
    confirmPassword: string;

    saving = false;
    active = false;

    constructor(
        injector: Injector,
        private _profileService: ProfileServiceProxy
    ) {
        super(injector);
    }

    show(): void {
        this.active = true;
        this.currentPassword = '';
        this.password = '';
        this.confirmPassword = '';

        this._profileService
            .getPasswordComplexitySetting()
            .subscribe(result => {
                this.passwordComplexitySetting = result.setting;
                this.modal.show();
            });
    }

    onShown(): void {
        $(this.currentPasswordInput.nativeElement).focus();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    save(): void {
        let input = new ChangePasswordInput();
        input.currentPassword = this.currentPassword;
        input.newPassword = this.password;

        this.saving = true;
        this._profileService
            .changePassword(input)
            .finally(() => {
                this.saving = false;
            })
            .subscribe(() => {
                this.notify.info(this.l('YourPasswordHasChangedSuccessfully'));
                this.close();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/profile/change-password-modal.component.ts